import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterGroupAttributeSelect({
  disabled = false,
  value = null,
  onChange = () => null,
}) {
  const { t } = useTranslate()

  const filterGroupAttributes = useStoreState((state) => state.filter.groupAttributes)

  const getFilterGroupAttributes = useStoreActions((actions) => actions.filter.getGroupAttributes)

  const options = _.map(filterGroupAttributes, (filterGroupAttribute) => {
    return {
      label: filterGroupAttribute?.name,
      value: filterGroupAttribute?.id,
    }
  })

  useAsync(async () => {
    getFilterGroupAttributes()
  }, [])

  const selectProps = {
    defaultValue: value,
    disabled,
    options,
    placeholder: t('Group Attribute'),
    onChange,
  }

  return (
    <Styled className="filter-group-attribute-select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
